/* Copyright (c) 2020-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import {
  GetRoleBindingsByUsersDocument,
  GetRolesDocument,
  useDeleteRoleBindingMutation,
} from "~/generated/graphql";
import { showError } from "~/services/toast";
import { removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export function useDeleteRoleBinding({ onSuccess, onError }: Props) {
  const [roleId, setRoleId] = useState("");
  const unifiedId = roleId.split("__")[2];

  const [deleteRoleBindingMutation, { client, ...rest }] =
    useDeleteRoleBindingMutation({
      onError: (error) => {
        showError(error.message);
        onError?.();
      },
      onCompleted: (data) => {
        if (data.removeRoleBinding) {
          onSuccess?.();
          removeFromApolloCache(
            client.cache,
            `RoleBinding:${roleId}`,
            "roleBindings"
          );
          removeFromApolloCache(client.cache, `Role:${unifiedId}`, "roles");
        }
      },
      refetchQueries: [GetRoleBindingsByUsersDocument, GetRolesDocument],
    });

  async function deleteRoleBinding(id: string) {
    setRoleId(id);
    await deleteRoleBindingMutation({
      variables: {
        id,
      },
    });
  }
  return [deleteRoleBinding, { client, ...rest }] as const;
}
